import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlaneRegularDiagonalIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m16.1 17.6 10-10L19.7 26zm8.4-11.7-10 10L6 12.5zM3.5 14l10.3 4.2L18 28.5a1.7 1.7 0 0 0 3.2 0l9-24.9a1.3 1.3 0 0 0-1.8-1.7L3.6 10.8a1.7 1.7 0 0 0-.1 3.2"
	})
});
export default SvgPlaneRegularDiagonalIcon;
